import { render } from "./ZugSortieren.vue?vue&type=template&id=73dd3e86&scoped=true"
import script from "./ZugSortieren.vue?vue&type=script&lang=js"
export * from "./ZugSortieren.vue?vue&type=script&lang=js"

import "./ZugSortieren.vue?vue&type=style&index=0&id=73dd3e86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73dd3e86"]])

export default __exports__